/*
Edition module's GoldenLayout installs itself to the global namespace on its own
and was misled by the existence of `exports` so let's clean up after the hack as well.
*/

/*
 XXX: `exports` is now simply the same as `self` (`window`)
      so we must no longer self-assign everything, especially window.location

var exportedSymbols = Object.keys(exports);

for (let name of exportedSymbols) {
    self[name] = exports[name];
}
*/

module = undefined;
exports = undefined;
